import { GridCellProps } from '@progress/kendo-react-grid';
import { Input } from '@progress/kendo-react-inputs';
import * as React from 'react';
import {InlineCellProps} from './CustomProps';
import { adjustUrl } from '../libs/StringHelper';
const LinkCell:React.FC<InlineCellProps> = ({field , dataItem , dataIndex, onChange, required, title,  ...props}) =>{
    const handleChange = (e: any) => {
		const item = { ...dataItem, [field!]: e.target.value };
		onChange!({
			dataItem: item,
			syntheticEvent: e.syntheticEvent,
			field: field,
			value: e.target.value,
            dataIndex:dataIndex
		});
	}
    return(
        <td title={title} className={props.className}>
            {
                dataItem.inEdit ? (
                        <Input
                            {...props}
                            required={required}
                            value={dataItem[field!]}
                            onChange={handleChange}
                        />
                    ) : (
                        <a title={title} href={ adjustUrl(dataItem[field!]) } target='_blank' style={{textDecorationLine: 'underline', color:'-webkit-link', textDecorationColor:"initial"}} >{dataItem[field!]}</a>
                    )
            }
        </td>
    )
}

export default LinkCell;